var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon21Contact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 18.6h-8.7c-3.3 0-5.9 2.7-5.9 5.9v3.7c0 1.1.9 2 2 2h16.7c1.1 0 2-.9 2-2v-3.7c-.1-3.2-2.8-5.9-6.1-5.9zm-4.3 6.5l-3.1-5h6.2l-3.1 5zm-8.8 3.1v-3.7c0-2.3 1.8-4.2 4-4.4l4.1 6.6v2H8.2c-.3 0-.5-.2-.5-.5zm17.6 0c0 .3-.2.5-.5.5h-7.6v-2l4.1-6.6c2.2.2 4 2.1 4 4.4v3.7zm-8.8-11.9c2.8 0 5-2 5-4.6v-1.6c0-1.5-.7-2.8-1.9-3.7-.1-1.6-1.4-2.9-3-2.9s-2.9 1.3-3 2.9c-1.2.9-1.9 2.2-1.9 3.7v1.6c-.2 2.6 2 4.6 4.8 4.6zm0-11.3c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6zM13 10.1c0-.8.3-1.5.8-2 .5.9 1.5 1.6 2.7 1.6S18.6 9 19.2 8c.5.6.8 1.3.8 2v1.6c0 1.8-1.5 3.1-3.5 3.1S13 13.4 13 11.6v-1.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon21Contact);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_21_Contact.fc9205a2.svg";
export { ForwardRef as ReactComponent };